import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { AdminSeasonOverview } from '../../models/season-admin';
import { SeasonAdminService } from '../../services/season-admin.service';
import { AdminPageHeaderComponent } from '../shared/admin-page-header/admin-page-header.component';

@Component({
  selector: 'app-seasons',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, TableModule, DatePipe, AdminPageHeaderComponent],
  templateUrl: './seasons.component.html',
  styleUrl: './seasons.component.scss',
})
export class SeasonsComponent implements OnInit {
  readonly title = 'Temporadas';
  readonly subtitle = 'Crie e gerencie temporadas, passe de batalha e configurações relacionadas.';

  seasons: AdminSeasonOverview[] = [];
  isLoading = false;
  searchTerm = '';
  statusFilter = '';
  feedbackError = '';

  constructor(private seasonService: SeasonAdminService, private router: Router) {}

  ngOnInit(): void {
    this.fetchSeasons();
  }

  fetchSeasons(): void {
    this.isLoading = true;
    this.seasonService
      .list({ search: this.searchTerm.trim(), status: this.statusFilter })
      .subscribe({
        next: (response) => {
          this.seasons = response || [];
          this.isLoading = false;
          this.feedbackError = '';
        },
        error: (error) => {
          this.seasons = [];
          this.isLoading = false;
          this.feedbackError = this.extractErrorMessage(
            error,
            'Não foi possível carregar as temporadas.'
          );
        },
      });
  }

  createSeason(): void {
    this.router.navigate(['/dashboard/temporadas/nova']);
  }

  detailSeason(seasonId: number): void {
    this.router.navigate(['/dashboard/temporadas', seasonId]);
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.statusFilter = '';
    this.fetchSeasons();
  }

  private extractErrorMessage(error: any, fallback: string): string {
    const response = error?.error;
    if (!response) {
      return fallback;
    }

    if (typeof response === 'string') {
      return response;
    }

    if (typeof response?.detail === 'string') {
      return response.detail;
    }

    const fieldMessages: string[] = [];
    Object.entries(response).forEach(([field, value]) => {
      if (Array.isArray(value)) {
        fieldMessages.push(`${field}: ${value.join(', ')}`);
      } else if (typeof value === 'string') {
        fieldMessages.push(`${field}: ${value}`);
      }
    });

    return fieldMessages.length > 0 ? fieldMessages.join(' | ') : fallback;
  }
}
